export const sourceOfSiteLeadSchema = {
	schema: {
		title: 'source of site lead schema',
		description: 'Source of site lead lookup (API list response)',
		version: 0,
		primaryKey: 'code',
		type: 'object',
		properties: {
			code: {
				type: 'string',
				maxLength: 50,
			},
			name: {
				type: 'string',
			},
			is_active: {
				type: 'boolean',
			},
			created_at: {
				type: 'string',
				maxLength: 100,
			},
			updated_at: {
				type: 'string',
				maxLength: 100,
			},
		},
		required: ['code', 'name', 'is_active', 'created_at', 'updated_at'],
	},
};
